export async function toteIndexUseCase(toteRepository) {
    const result = await toteRepository.index();

    result.forEach(x => {
        x = new toteRepository.model(x);

        if (!x.isValid()) {
            throw new Error("tote inválido");
        }
    })

    return result;
}